import {
  getAboveNode,
  getEditorString,
  isType,
  PlateEditor,
  replaceNodeChildren,
  TText,
  Value,
} from '@udecode/plate-common';

import {
  ELEMENT_ANCHOR_LINK,
  ELEMENT_INTERLINK,
  ELEMENT_LINK,
  MyInterlinkElement,
} from '../../../plateTypes';

/**
 * If the text is different than the link above text, replace link children by a
 * new text. The new text has the same marks than the first text replaced.
 */
export const upsertLinkText = <V extends Value>(
  editor: PlateEditor<V>,
  { text }: { text: string | undefined },
): void => {
  const newLink = getAboveNode<MyInterlinkElement>(editor, {
    match: (node) =>
      isType(editor, node, [
        ELEMENT_INTERLINK,
        ELEMENT_ANCHOR_LINK,
        ELEMENT_LINK,
      ]),
  });

  if (newLink) {
    const [newLinkNode, newLinkPath] = newLink;

    if (text?.length && text !== getEditorString(editor, newLinkPath)) {
      const firstText = newLinkNode.children[0];
      // remove link children
      replaceNodeChildren<TText>(editor, {
        at: newLinkPath,
        nodes: { ...firstText, text },
        insertOptions: {
          select: true,
        },
      });
    }
  }
};
